import { render, staticRenderFns } from "./OsCustomerSettingsForm.vue?vue&type=template&id=7aedb90e&scoped=true"
import script from "./OsCustomerSettingsForm.vue?vue&type=script&lang=ts"
export * from "./OsCustomerSettingsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aedb90e",
  null
  
)

export default component.exports